import { render, staticRenderFns } from "./StockArchive.vue?vue&type=template&id=046ac0b4&"
import script from "./StockArchive.vue?vue&type=script&lang=js&"
export * from "./StockArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports